const appointmentAction = {
  index: {
    tab: {
      headers: {
        name: "Nom",
        code: "Code",
        price: "Prix",
        quantityCredit: "Crédit",
      }
    }
  },
  tab: {
    main: "Action",
    previousPrices: "Prix précedents",
    filters: "Filtres"
  },
  new: {
    title: "Nouvelle action"
  },
  search: {
    name: "Nom",
  }
};

export default appointmentAction;
